module.exports = __webpack_public_path__ + "img/how-to-navigate-2.0c7ebc34.jpg";